import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section id="flow" className="py-24 bg-paper pixel-grid">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <p className="text-ember text-sm font-bold uppercase tracking-[0.2em]">{t.flow.kicker}</p>
          <h2 className="mt-4 font-display font-extrabold text-4xl lg:text-5xl text-ink leading-tight">
            {t.flow.title}{' '}
            <span className="text-mint">{t.flow.titleAccent}</span>
          </h2>
          <p className="mt-5 text-lg text-mute leading-relaxed">{t.flow.intro}</p>
        </div>

        <ol className="grid md:grid-cols-3 gap-10 md:gap-8 relative">
          <div
            className="hidden md:block absolute top-7 left-[12%] right-[12%] h-px bg-line origin-left animate-draw-line"
            aria-hidden
          />
          {t.flow.steps.map((step) => (
            <li key={step.num} className="relative">
              <span className="inline-flex items-center justify-center w-14 h-14 bg-ink text-mint-soft font-display font-extrabold text-xl">
                {step.num}
              </span>
              <h3 className="mt-6 font-display font-bold text-xl text-ink">{step.title}</h3>
              <p className="mt-2 text-mute leading-relaxed text-sm sm:text-base">{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
